import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import UneditableInput from '../../components/UneditableInput';
import EditableDateInput from '../../components/EditableDateInput/EditableDateInput';

import { getCustomDomainsBySearch, updateCustomDomain } from '../../services/customDomain';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress, Button } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const CustomDomainInformation = props => {
  const dispatch = useDispatch();
  const [customDomain, setCustomDomain] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayCustomDomain();
  }, []);

  const displayCustomDomain = async () => {
    const customDomainId = props.match.params.id;

    try {
      setIsLoading(true);
      const { data } = await getCustomDomainsBySearch('id', customDomainId);

      setCustomDomain(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this Custom Domain. 😔'));
      console.log(error);
    }
  };

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateCustomDomain(customDomain.id, customDomain);

      dispatch(showAlert('success', 'Custom Domain has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Custom Domain. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>Custom Domain: {customDomain?.domain}</h1>
      </div>

      <section className="update-section">
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableDateInput data={customDomain} setData={setCustomDomain} labels={['deletedAt']} />
            <EditableInput
              data={customDomain}
              setData={setCustomDomain}
              labels={['channelId', 'cloudFrontId', 'domain', 'status', 'urlDistribution']}
            />
            <UneditableInput data={customDomain} labels={Object.keys(customDomain)} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update Custom Domain
          </Button>
        </form>
      </section>
    </>
  );
};

export default CustomDomainInformation;
